<template>
  <admin-wrapper title-translation-path="admin.SEWER" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers scope="sewer" class="pt-8" schema_scope="sewer" :tab-prop="tab" />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'SewerSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'sewer_data_module_enabled',
        translationPath: 'admin.SEWER',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.SEWER') }),
      };
    },
  },
};
</script>
